import { gql } from "@apollo/client";

export const REMOVE_VEHICLE_ON_HOLD_MUTATION = gql`
  mutation removeVehicleHold($vehicleId: ID!, $holdId: ID!) {
    removeVehicleHold(vehicleId: $vehicleId, holdId: $holdId) {
      success
    }
  }
`;
